var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.75C15 6.16421 14.6642 6.5 14.25 6.5H9.75C9.33579 6.5 9 6.16421 9 5.75C9 5.33579 9.33579 5 9.75 5H14.25C14.6642 5 15 5.33579 15 5.75Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1.25C18.5188 1.25 19.75 2.48122 19.75 4L19.75 20C19.75 21.5188 18.5188 22.75 17 22.75H7C5.48122 22.75 4.25 21.5188 4.25 20L4.25 4C4.25 2.48122 5.48122 1.25 7 1.25L17 1.25ZM18.25 4C18.25 3.30964 17.6904 2.75 17 2.75L7 2.75C6.30965 2.75 5.75 3.30964 5.75 4L5.75 20C5.75 20.6904 6.30964 21.25 7 21.25H17C17.6904 21.25 18.25 20.6904 18.25 20L18.25 4Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyCard);
export default __webpack_public_path__ + "static/media/KeyCard.0809d63b6ef82790d5b1001829929696.svg";
export { ForwardRef as ReactComponent };